import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"
import {
    AvField,
    AvForm
} from "availity-reactstrap-validation";
import { Table, Thead, Tbody, Tr, Th, Td, } from "react-super-responsive-table"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService"

import IndexBloc from "../Blocs/IndexBlock"
import apiResponse from '../../../../../services/apiResponse'
import Select from "react-select"
import moment from "moment"
import DataTableBloc from "../Blocs/DataTableBloc"
import DetailModal from "./DetailModal"

var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];
        
        return newObj;
    });
}; 
const defaultMonthOption = () => {
    let option = []
    option.push({ value: 1, label: 'Januari' });
    option.push({ value: 2, label: 'Februari' });
    option.push({ value: 3, label: 'Maret' });
    option.push({ value: 4, label: 'April' });
    option.push({ value: 5, label: 'Mei' });
    option.push({ value: 6, label: 'Juni' });
    option.push({ value: 7, label: 'Juli' });
    option.push({ value: 8, label: 'Agustus' });
    option.push({ value: 9, label: 'September' });
    option.push({ value: 10, label: 'Oktober' });
    option.push({ value: 11, label: 'November' });
    option.push({ value: 12, label: 'Desember' });

    return option;
}
const createOption = (label) => ({
    label: label,
    value: label,
  });
const defaultYearOption = () => {
    let option = []
    var d = new Date();
    var n = d.getFullYear();
    for(let i = n-10; i < n+1; i++) {
    	option.push(createOption(i))
    }

    return option
}
class TableThirdComponent extends Component {
    indexBloc = new IndexBloc()
    dataTableBloc = new DataTableBloc()
    
    source
    historyTable = 'mutasirekomendasihistorylist'
    defaultOrder = 'employee_transfer_detail_create_date'
    defaultSize = 10
    defaultSort = 'asc'
    
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
    constructor(props) {
        super(props)
        this.state = {
            loadingTable: false,
            cancelDate: null,
            rows: [],
            tooltip: false,
            detailUuid: null,
            defaultSize: 10,
            totalRow: 0,
            loadingTable: false,
            positionOption: [],
            employeeOption: [],
            employee_transfer_detail_uuid: '',
            wuAll: [{}],
            workunitfilter: '',
            dataForm: {},
            month_filter: 0,
            year_filter: 0,
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    
    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
    loadData = async () => {
        this.setState({
            loadingTable: true
        });
        // var additionalFilter = {
        //     ...this.props.additionalFilter,
        //     workunitfilter: this.state.workunitfilter,
        //     month_filter: this.state.month_filter,
        //     year_filter: this.state.year_filter
        // };
        
        // this.dataTableBloc.fetchRowTableRiwayat(additionalFilter);
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            workunitfilter: this.state.workunitfilter,
            month_filter: this.state.month_filter,
            year_filter: this.state.year_filter,
            status: 1
        }
        await this.dataTableBloc.fetchRowTableRiwayat(query, this.source.token);
    }
    
    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }
    do_export = async () => {
        this.setState({
            loading: true
        });
        var additionalFilter = {
            ...this.props.additionalFilter,
            workunitfilter: this.state.workunitfilter,
            month_filter: this.state.month_filter,
            year_filter: this.state.year_filter
        };
        this.dataTableBloc.fetchExportHistory(additionalFilter);
    }
    delmapping = (param) => {
        this.setState({
            confirm:true,
            employee_transfer_detail_uuid : param
        })
    }
    handlerOnSubmit = (e, values) => {
        e.preventDefault();
        const allData = {
            ...values
        };
    
        this.setState({
            dataForm: allData,
            confirmsubmit: true
        });
    }
    submitData = async () => {
        await this.dataTableBloc.fetchProses(this.state.dataForm);
    }
    
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
                case 'confirm':
                    forState = {
                        loading: true,
                        confirm: false
                    }
                    this.dataTableBloc.fetchDelMapping({employee_transfer_detail_uuid:this.state.employee_transfer_detail_uuid});
                    break;
                    case 'success':
                        forState = {
                            success: false,
                            redirect: true
                        }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    componentDidMount() {
        this.setTokenAPI()
        // this.loadData()
        this.dataTableBloc.exportHistoryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        this.dataTableBloc.riwayatChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        // loading: true,
                        loadingTable : true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    console.log(response.result[0])
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        // loading: false,
                        loadingTable : false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.delChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    
                    break
                case apiResponse.LOADING:
                    
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    console.log(response)
                    this.setTokenAPI()
                    this.setState({
                        loading: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
              case apiResponse.COMPLETED:
                console.log(result)
                this.setState({
                  positionOption: reformatOptions(
                    result.data.response.result,
                    "position_name",
                    "position_uuid"
                  ),
                  loadingPosition: false,
                });
                break;
              case apiResponse.ERROR:
                break;
              default:
                break;
            }
          })
        this.dataTableBloc.fetchPosition({});
        this.dataTableBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result)
                    this.setState({
                        employeeOption: reformatOptions(
                            result.data.response.result,
                            "employee_full_name",
                            "employee_uuid"
                        ),
                        loadingEmployee: false,
                });
                break;
              case apiResponse.ERROR:
                  break;
                  default:
                      break;
                    }
                })
                this.dataTableBloc.fetchEmployee({});

            }
            
    componentWillUnmount() {
        this.dataTableBloc.riwayatChannel.unsubscribe()
        this.dataTableBloc.employeeChannel.unsubscribe()
        this.dataTableBloc.positionChannel.unsubscribe()
    }
    columns = [
        {
            key: "employee_transfer_detail_employee_full_name",
            text: "Nama",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ width: '200px' }}> {/* Memperbesar ukuran kolom */}
                        {record.employee_transfer_detail_employee_full_name}
                    </div>
                );
            }
        },
        {
            key: "employee_transfer_detail_old_position_name",
            text: "Jabatan",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ width: '250px' }}> {/* Memperbesar ukuran kolom */}
                        {record.employee_transfer_detail_old_position_name}
                    </div>
                );
            }
        },
        {
            key: "rank_group_room",
            text: "Golongan",
            sortable: false,
            cell: record => {
                return record.rank_group_room;
            }
        },
        // {
        //     key: "masa_kerja_eselon_1",
        //     text: "Masa Kerja Eselon-1",
        //     sortable: false,
        //     cell: record => {
        //         return record.masa_kerja_eselon_1 === "00:00:00" ? "0 tahun 0 bulan 0 hari" : record.masa_kerja_eselon_1.replace(/day/, 'hari').replace(/haris/, 'hari').replace(/mon/, 'bulan').replace(/bulans/, 'bulan').replace(/year/, 'tahun').replace(/tahuns/, 'tahun'); 
        //     }
        // },
        {
            key: "masa_kerja_eselon_2",
            text: "Masa Kerja Eselon-2",
            sortable: false,
            cell: record => {
                return record.masa_kerja_eselon_2; 
            }
        },
        {
            key: "action",
            text: "",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                {
                    <Button
                        className="btn btn-light"
                        type="button" 
                        disabled
                    >
                        <i className="fas fa-arrow-right text-muted text-success"></i>
                    </Button>
                }
                    </div>
                );
            }
        },
        // {
        //     key: "employee_transfer_detail_id",
        //     text: "Jabatan",
        //     sortable: true,
        //     cell: record => {
        //         return (
        //         <>
            
                
                   
        //         <Select
        //             name={`position_${record.employee_uuid}`}
        //             errorMessage="Pilih Jabatan"
        //             placeholder="Pilih Jabatan"
        //             options={this.state.positionOption}
        //             isDisabled={true}
        //             styles={{ container: (provided) => ({ ...provided, width: '200px' }) }}
        //             validate={{ required: { value: true } }}
        //             value={[{'label':record.employee_transfer_detail_position_name,'value':record.employee_transfer_detail_position_uuid}]}
        //         />
                  
        //         </>
        //         );
        //     }
        // },
        // {
        //     key: "employee_uuid",
        //     text: "Unit kerja tujuan",
        //     sortable: true,
        //     cell: record => {
        //         return (
        //             <>
                
        //         {
        //             <Select
        //                 name={`work_unit_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
        //                 required={true}
        //                 // options={this.props.wuall}
        //                 classNamePrefix="select2-unit"
        //                 styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
        //                 value={[{'label':record.employee_transfer_detail_work_unit_name,'value':record.employee_transfer_detail_work_unit_uuid}]}
        //                 isDisabled={true}
        //             />
        //         }
        //     </>
        //         );
        //     }
        // },
        // {
        //     key: "employee_nip",
        //     text: "Nama Pegawai Pengganti",
        //     sortable: false,
        //     cell: record => {
        //         return (
        //             <>
        //                 <Input
        //                     type="text"
        //                     value={record.employee_transfer_detail_replacement_name}
        //                     disabled={true}
        //                 />
        //             </>
        //         );
        //     }
        // },
        {
            key: "employee_transfer_detail_id",
            text: "Jabatan",
            sortable: false,
            cell: record => {
                return record.employee_transfer_detail_position_name;
            }
        },
        {
            key: "employee_uuid",
            text: "Unit Kerja Tujuan",
            sortable: false,
            cell: record => {
                return record.employee_transfer_detail_work_unit_name;
            }
        },
        {
            key: "employee_nip",
            text: "Nama Pegawai Pengganti",
            sortable: false,
            cell: record => {
                return record.employee_transfer_detail_replacement_name;
            }
        },
        {
            key: "action",
            text: "Action",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                {
                    <Button
                        className="btn btn-info btn-sm"
                        type="button" 
                        onClick={() => {
                            this.setState({
                                StartDetailModal: true,
                                employee_nip: record.employee_nip,
                                uuid: record.employee_transfer_detail_uuid,
                                nama: record.employee_transfer_detail_employee_full_name,
                                rank_group_room: record.rank_group_room,
                                employee_transfer_detail_decree_date: record.employee_transfer_detail_decree_date,
                                employee_transfer_detail_decree_number: record.employee_transfer_detail_decree_number,
                                employee_transfer_detail_tmt_date: record.employee_transfer_detail_tmt_date,
                                employee_transfer_detail_old_work_unit_name: record.employee_transfer_detail_old_work_unit_name,
                                employee_transfer_detail_old_position_name: record.employee_transfer_detail_old_position_name,
                                employee_transfer_detail_work_unit_name: record.employee_transfer_detail_work_unit_name,
                                employee_transfer_detail_position_name: record.employee_transfer_detail_position_name,
                                employee_transfer_detail_replacement_name: record.employee_transfer_detail_replacement_name,
                                employee_transfer_detail_replacement_work_unit_name: record.employee_transfer_detail_replacement_work_unit_name,
                                employee_transfer_mutasi_jenis: record.employee_transfer_mutasi_jenis,
                            }); // Menyimpan state setelah penghapusan
                        }} 
                    >
                        <i className="fas fa-info-circle text-white text-success"></i>
                    </Button>
                }
                    </div>
                );
            }
        },
    ]

    render() {
        return (
            <>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                    this.handlerOnSubmit(e, values)
                    }
                >
                    <Row className="mb-3">
                        <Col md="12">
                            <Row className="mb-2">
                                <Col md="3">
                                    <Label>Unit Kerja</Label>
                                    <Select
                                        id="wu_filter"
                                        name="wu_filter" // Menggunakan UUID pegawai sebagai nama unik
                                        required={true}
                                        options={[{ value: '', label: 'Semua' }, ...this.props.wuall]}
                                        classNamePrefix="select2-unit"// Memperbesar ukuran kolom
                                        onChange={(selectedOption) => {
                                            this.setState(prevState => ({
                                                workunitfilter: selectedOption.value
                                            }));
                                            
                                        }}
                                    />
                                </Col>
                                <Col md="2">
                                    <Label>Bulan</Label>
                                    <Select
                                        id="month_filter"
                                        name="month_filter" // Menggunakan UUID pegawai sebagai nama unik
                                        required={true}
                                        options={defaultMonthOption()}
                                        classNamePrefix="select2-unit"// Memperbesar ukuran kolom
                                        onChange={(selectedOption) => {
                                            this.setState(prevState => ({
                                                month_filter: selectedOption.value
                                            }));
                                            
                                        }}
                                    />
                                </Col>
                                <Col md="2">
                                    <Label>Tahun</Label>
                                    <Select
                                        id="year_filter"
                                        name="year_filter" // Menggunakan UUID pegawai sebagai nama unik
                                        required={true}
                                        options={defaultYearOption()}
                                        classNamePrefix="select2-unit"// Memperbesar ukuran kolom
                                        onChange={(selectedOption) => {
                                            this.setState(prevState => ({
                                                year_filter: selectedOption.value
                                            }));
                                            
                                        }}
                                    />
                                </Col>
                                <Col md="3" className="mt-4">
                                <Button
                                    className="btn btn-success"
                                    type="button" 
                                    onClick={() => {
                                        this.setTokenAPI();
                                    }} >
                                    <i className="fas fa-search text-white"></i> Cari
                                </Button>
                                &nbsp;
                                <Button
                                    className="btn btn-success"
                                    type="button" 
                                    onClick={() => {
                                        this.do_export();
                                    }} >
                                    <i className="fas fa-file-excel text-white"></i> Export
                                </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="7"><b>Unit Kerja Sekarang</b></Col>
                        <Col md="5"><b>Unit Kerja Baru</b></Col>
                    </Row>
                    <hr />
                    <div className="table-responsive">
                        <MKIDatatable
                            className={this.configDatatable.tableClass}
                            config={this.configDatatable}
                            records={this.state.rows}
                            columns={[
                                ...this.columns,
                            ]}
                            dynamic={true}
                            total_record={this.state.totalRow}
                            initial={{
                                ...this.state.filter,
                                pageSize: this.state.defaultSize // Menyimpan limit per halaman di sini
                            }}
                            onChange={(filter) => {
                                this.setState({
                                    loadingTable: true,
                                    filter: filter
                                }, function () {
                                    this.setTokenAPI()
                                });
                            }}
                            loading={this.state.loadingTable}
                        />

                        <ConfirmAlert
                            confirmTitle="Konfirmasi!"
                            confirmInfo="Apakah anda yakin akan membatalkan data usulan mutasi ini?"

                            loadingTitle="Mengambil data"
                            loadingInfo="Tunggu beberapa saat"

                            successTitle="Berhasil!"
                            successInfo="Data berhasil diexport"

                            failedTitle="Gagal!"
                            failedInfo="Data gagal diexport"

                            showConfirm={this.state.confirm}
                            showLoading={this.state.loading}
                            showSuccess={this.state.success}
                            showFailed={this.state.failed}

                            response={this.confirmResponse}
                        />
                        
                    </div>
                    <DetailModal
                        uuid={this.state.employee_transfer_detail_uuid}
                        nip={this.state.employee_nip}
                        nama={this.state.nama}
                        rank_group_room={this.state.rank_group_room}
                        employee_transfer_detail_decree_date={this.state.employee_transfer_detail_decree_date}
                        employee_transfer_detail_decree_number={this.state.employee_transfer_detail_decree_number}
                        employee_transfer_detail_tmt_date={this.state.employee_transfer_detail_tmt_date}
                        employee_transfer_detail_old_work_unit_name= {this.state.employee_transfer_detail_old_work_unit_name}
                        employee_transfer_detail_old_position_name= {this.state.employee_transfer_detail_old_position_name}
                        employee_transfer_detail_work_unit_name= {this.state.employee_transfer_detail_work_unit_name}
                        employee_transfer_detail_position_name= {this.state.employee_transfer_detail_position_name}
                        employee_transfer_detail_replacement_name= {this.state.employee_transfer_detail_replacement_name}
                        employee_transfer_detail_replacement_work_unit_name= {this.state.employee_transfer_detail_replacement_work_unit_name}
                        employee_transfer_mutasi_jenis= {this.state.employee_transfer_mutasi_jenis}
                        modal={this.state.StartDetailModal}
                        toggle={() => this.setState({ StartDetailModal: !this.state.StartDetailModal })}
                        handleReload={() => this.setTokenAPI()}
                    />
                </AvForm>
            </>
        )
    }

}

export default TableThirdComponent